var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path5, _path6, _circle, _path7, _path8, _path9, _circle2, _path10, _circle3, _path11, _circle4, _path12, _path13, _path14, _path15, _ellipse, _ellipse2, _path16, _path17, _circle5, _ellipse3, _ellipse4, _path18, _circle6, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _circle7, _rect10, _path31, _path32, _g, _path33, _path34;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNextSteps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 145.416,
    height: 162.313,
    viewBox: "0 0 145.416 162.313",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_3351",
    "data-name": "Group 3351",
    transform: "translate(-0.002 0)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M837.566,696.651a5.6,5.6,0,0,1-5.4-.952c-1.892-1.588-2.486-4.2-2.968-6.628l-1.428-7.166,2.989,2.058a21.775,21.775,0,0,1,5.836,5.152c1.489,2.144,2.138,5.071.942,7.391",
    transform: "translate(-698.989 -543.661)",
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M853.422,733.209a28.93,28.93,0,0,0,.4-6.664,10.479,10.479,0,0,0-2.021-5.495,9.142,9.142,0,0,0-2.345-2.125c-.235-.148-.45.224-.217.371a8.689,8.689,0,0,1,3.437,4.147,13.913,13.913,0,0,1,.738,6c-.078,1.223-.243,2.437-.41,3.651a.222.222,0,0,0,.15.264.216.216,0,0,0,.264-.15Z",
    transform: "translate(-715.101 -571.543)",
    fill: "#f2f2f2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6676",
    "data-name": "Path 6676",
    d: "M439.55,245.38H314.489V120.319H439.55Z",
    transform: "translate(-312.063 -120.319)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6677",
    "data-name": "Path 6677",
    d: "M439.55,245.38H314.489V120.319H439.55Zm-123.213-1.848H437.7V122.167H316.337Z",
    transform: "translate(-312.063 -120.319)",
    fill: "#e5e5e5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3519",
    "data-name": "Rectangle 3519",
    width: 54.157,
    height: 1.687,
    transform: "translate(51.176 19.566)",
    fill: "#e5e5e5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3520",
    "data-name": "Rectangle 3520",
    width: 54.157,
    height: 1.687,
    transform: "translate(51.176 23.952)",
    fill: "#e5e5e5"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3521",
    "data-name": "Rectangle 3521",
    width: 54.157,
    height: 1.687,
    transform: "translate(51.176 28.338)",
    fill: "#e5e5e5"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3522",
    "data-name": "Rectangle 3522",
    width: 54.157,
    height: 1.687,
    transform: "translate(51.176 57.229)",
    fill: "#e5e5e5"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3523",
    "data-name": "Rectangle 3523",
    width: 54.157,
    height: 1.687,
    transform: "translate(51.176 61.616)",
    fill: "#e5e5e5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3524",
    "data-name": "Rectangle 3524",
    width: 54.157,
    height: 1.687,
    transform: "translate(51.176 66.002)",
    fill: "#e5e5e5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3525",
    "data-name": "Rectangle 3525",
    width: 54.157,
    height: 1.687,
    transform: "translate(51.176 94.893)",
    fill: "#e5e5e5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3526",
    "data-name": "Rectangle 3526",
    width: 54.157,
    height: 1.687,
    transform: "translate(51.176 99.279)",
    fill: "#e5e5e5"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3527",
    "data-name": "Rectangle 3527",
    width: 54.157,
    height: 1.687,
    transform: "translate(51.176 103.665)",
    fill: "#e5e5e5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6678",
    "data-name": "Path 6678",
    d: "M389.988,244.686a18.089,18.089,0,0,0-2.886-1.215l-.127-1.4-5.148-.555-.654,1.795-1.847.693a.9.9,0,0,0-.187.1h0a.915.915,0,0,0-.391.609.936.936,0,0,0,.014.367l.1.4c.141.084.285.164.43.24l.092.047c.211.109.426.213.646.309l.139.059.01,0c.1.043.207.084.312.123a10.257,10.257,0,0,0,1.058.34,10.883,10.883,0,0,0,2.806.367c.346,0,.687-.016,1.025-.049a10.84,10.84,0,0,0,2.273-.459l.006,0a10.673,10.673,0,0,0,1.365-.541s.006,0,.008,0c.1-.047.2-.1.293-.146l.047-.023c.078-.041.156-.082.234-.125.2-.107.387-.221.576-.342.053-.031.1-.064.156-.1.074-.049.148-.1.221-.152C390.373,244.9,390.183,244.791,389.988,244.686Z",
    transform: "translate(-360.493 -211.679)",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6679",
    "data-name": "Path 6679",
    d: "M377.578,253.462l-.322-1.455h-.842l-.025,0h0a1.824,1.824,0,0,0-.847.293,1.877,1.877,0,0,0-.453.406c.25.189.51.365.777.533l.012.006c.076.047.154.094.232.139.141.084.285.164.43.24l.092.047c.211.109.426.213.646.309l.139.059.01,0c.1.043.207.084.312.123Z",
    transform: "translate(-357.743 -219.59)",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_24",
    "data-name": "Ellipse 24",
    cx: 3.707,
    cy: 3.707,
    r: 3.707,
    transform: "translate(19.999 21.531)",
    fill: "#ffb8b8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6680",
    "data-name": "Path 6680",
    d: "M385.793,204.855a2.344,2.344,0,0,0,1.632.635,15.375,15.375,0,0,0,4.175-.341c.085.823-.147,1.709.338,2.386a11.078,11.078,0,0,0,.394-2.511,2.4,2.4,0,0,0-.139-1.075.989.989,0,0,0-.843-.621,2.112,2.112,0,0,1,.942-.4l-1.177-.592.3-.31-2.131-.13.617-.392a13.384,13.384,0,0,0-2.8-.089,2.407,2.407,0,0,0-1.24.345.9.9,0,0,0-.337,1.121,1.628,1.628,0,0,0-1.241.984,2.628,2.628,0,0,0-.094,1.263,8.956,8.956,0,0,0,.47,1.986Z",
    transform: "translate(-364.576 -181.422)",
    fill: "#2f2e41"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6681",
    "data-name": "Path 6681",
    d: "M378.507,184.158a10.879,10.879,0,1,0-18.8,10.334c.1.123.2.246.3.365l.021.023a10.556,10.556,0,0,0,.81.836c.074.068.152.139.23.205.148.133.3.26.459.381.062.049.123.1.187.145.25.189.51.365.777.533l.012.006c.076.047.154.094.232.139.141.084.285.164.43.24l.092.047c.211.109.426.213.646.309l.139.059.01,0c.1.043.207.084.312.123a10.264,10.264,0,0,0,1.058.34,10.884,10.884,0,0,0,2.806.367c.346,0,.687-.016,1.025-.049a10.839,10.839,0,0,0,2.273-.459l.006,0a10.669,10.669,0,0,0,1.365-.541l.008,0c.1-.047.2-.1.293-.146l.047-.023c.078-.041.156-.082.234-.125.2-.107.387-.221.576-.342.053-.031.1-.064.156-.1.074-.049.148-.1.221-.152.1-.066.191-.135.285-.205.029-.021.061-.043.09-.066a10.875,10.875,0,0,0,3.695-12.24Zm-4.054,11.766c-.064.051-.131.1-.2.145s-.129.1-.2.139-.113.08-.172.117l-.018.012c-.043.029-.086.057-.129.084q-.243.152-.492.293l-.053.029c-.074.041-.148.08-.223.119l-.031.016-.012.006c-.094.049-.189.1-.285.141a9.582,9.582,0,0,1-1.138.461c-.051.018-.1.035-.152.051a10.243,10.243,0,0,1-2.152.437c-.32.029-.644.045-.971.045a10.145,10.145,0,0,1-2.654-.348,9.643,9.643,0,0,1-1.3-.441l-.066-.027-.066-.027-.068-.031c-.184-.08-.365-.168-.543-.26l-.086-.045c-.217-.113-.43-.234-.637-.363-.061-.037-.123-.076-.182-.117l-.045-.029c-.139-.092-.277-.187-.412-.287-.092-.068-.184-.137-.273-.207-.15-.113-.295-.234-.435-.359-.074-.062-.146-.131-.217-.2a9.928,9.928,0,0,1-.785-.812c-.082-.094-.162-.187-.238-.285a.735.735,0,0,1-.049-.061,10.283,10.283,0,1,1,14.279,1.8Z",
    transform: "translate(-344.376 -162.938)",
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6682",
    "data-name": "Path 6682",
    d: "M378.508,337.158a10.879,10.879,0,1,0-18.8,10.334c.1.123.2.246.3.365l.021.023a10.57,10.57,0,0,0,.81.836c.074.068.152.139.23.205.148.133.3.26.459.381a10.691,10.691,0,0,0,.965.678l.012.006c.217.135.437.26.662.379l.092.047c.211.109.426.213.646.309l.139.059.01,0a10.575,10.575,0,0,0,1.371.463,10.883,10.883,0,0,0,2.806.367c.346,0,.687-.016,1.025-.049a10.837,10.837,0,0,0,2.273-.459l.006,0a10.665,10.665,0,0,0,1.365-.541s.006,0,.008,0c.1-.047.2-.1.293-.146l.047-.023c.078-.041.156-.082.234-.125.2-.107.387-.221.576-.342.053-.031.1-.064.156-.1.172-.113.342-.234.506-.357.029-.021.061-.043.09-.066A10.875,10.875,0,0,0,378.508,337.158Z",
    transform: "translate(-344.376 -278.275)",
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_188",
    "data-name": "Ellipse 188",
    cx: 1.63,
    cy: 1.63,
    r: 1.63,
    transform: "translate(25.817 63.683)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_969",
    "data-name": "Path 969",
    d: "M414.081,378.455a1.631,1.631,0,0,1,1.435,2.4,1.63,1.63,0,1,0-2.708-1.791,1.626,1.626,0,0,1,1.273-.613Z",
    transform: "translate(-386.179 -314.727)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_189",
    "data-name": "Ellipse 189",
    cx: 4.789,
    cy: 4.789,
    r: 4.789,
    transform: "translate(19.612 55.731)",
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_970",
    "data-name": "Path 970",
    d: "M384,348.478a4.789,4.789,0,0,1,6.638-.5c-.039-.037-.078-.075-.119-.111A4.789,4.789,0,1,0,384.124,355l.027.024c.041.036.082.07.124.1a4.789,4.789,0,0,1-.279-6.651Z",
    transform: "translate(-363.355 -290.929)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_190",
    "data-name": "Ellipse 190",
    cx: 3.085,
    cy: 3.085,
    r: 3.085,
    transform: "translate(21.276 59.1)",
    fill: "#a0616a"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6683",
    "data-name": "Path 6683",
    d: "M383.054,391.1v1.035c-.189.121-.381.234-.576.342-.078.043-.156.084-.234.125l-.047.023c-.1.049-.193.1-.293.146l-.008,0a10.653,10.653,0,0,1-1.365.541l-.006,0a10.841,10.841,0,0,1-2.273.459c-.338.033-.68.049-1.025.049a10.883,10.883,0,0,1-2.806-.367A10.572,10.572,0,0,1,373.05,393l-.01,0-.139-.059c-.221-.1-.435-.2-.646-.309l-.092-.047c-.225-.119-.445-.244-.662-.379l-.012-.006a10.7,10.7,0,0,1-.965-.678c-.158-.121-.31-.248-.459-.381-.078-.066-.156-.137-.23-.205a10.56,10.56,0,0,1-.81-.836,3.951,3.951,0,0,1,.148-.6l0,0a.87.87,0,0,1,.041-.1.768.768,0,0,1,.037-.082,1.855,1.855,0,0,1,1.767-.851c.443-.02.933,0,1.451,0,.273,0,.556-.012.84-.037,1.787-.162,1.463-1.217,1.543-1.785.08-.551.576-.074.609-.043l0,0a6.3,6.3,0,0,0,3.242.568c.191-.023.383-.037.574-.043.5-.006.395.139.221.258a2.171,2.171,0,0,1-.264.148s-.08.488-.162,1.219c-.078.7,1.262,1.027,1.373,1.053a.011.011,0,0,0,.008,0,2.69,2.69,0,0,1,1.486.039h0A1.761,1.761,0,0,1,383.054,391.1Z",
    transform: "translate(-353.174 -320.879)",
    fill: "#6c63ff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6684",
    "data-name": "Path 6684",
    d: "M378.99,397.72c0,.145,0,.283-.01.414,0,.078-.006.154-.01.227l-.01,0-.139-.059c-.221-.1-.435-.2-.646-.309l-.092-.047c-.225-.119-.445-.244-.662-.379.006-.068.016-.137.025-.205.021-.15.039-.3.051-.453a6.285,6.285,0,0,0-.557-3.078v0c-.039-.078-.062-.121-.062-.121a1.177,1.177,0,0,1,1.379,0,.487.487,0,0,1,.135.117C378.881,394.4,379.013,396.336,378.99,397.72Z",
    transform: "translate(-359.094 -326.243)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6685",
    "data-name": "Path 6685",
    d: "M416.764,401.845c-.008.219-.02.447-.033.68v0s-.006,0-.008,0a10.667,10.667,0,0,1-1.365.541l-.006,0-.021-.549,0-.072-.1-2.671a.448.448,0,0,1,.447-.469h.99c.049,0,.084.1.107.279v0a16.922,16.922,0,0,1-.006,2.252Z",
    transform: "translate(-388 -330.633)",
    fill: "#2f2e41"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_975",
    "data-name": "Path 975",
    d: "M392.874,357.267v3.085h.714l.909-.974-.122.974h3.158l-.2-.974.391.974h.5v-3.085Z",
    transform: "translate(-371.152 -298.938)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_191",
    "data-name": "Ellipse 191",
    cx: 0.244,
    cy: 0.446,
    rx: 0.244,
    ry: 0.446,
    transform: "translate(20.992 61.089)",
    fill: "#a0616a"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_192",
    "data-name": "Ellipse 192",
    cx: 0.244,
    cy: 0.446,
    rx: 0.244,
    ry: 0.446,
    transform: "translate(27.242 61.089)",
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6686",
    "data-name": "Path 6686",
    d: "M424.2,404.166c-.164.123-.334.244-.506.357-.053.035-.1.068-.156.1-.189.121-.381.234-.576.342-.078.043-.156.084-.234.125v-2.152s.312.25.81.666l.2.166C423.873,403.89,424.029,404.023,424.2,404.166Z",
    transform: "translate(-393.653 -333.366)",
    fill: "#6c63ff"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6687",
    "data-name": "Path 6687",
    d: "M378.508,337.158a10.879,10.879,0,1,0-18.8,10.334c.1.123.2.246.3.365l.021.023a10.57,10.57,0,0,0,.81.836c.074.068.152.139.23.205.148.133.3.26.459.381a10.691,10.691,0,0,0,.965.678l.012.006c.217.135.437.26.662.379l.092.047c.211.109.426.213.646.309l.139.059.01,0a10.575,10.575,0,0,0,1.371.463,10.883,10.883,0,0,0,2.806.367c.346,0,.687-.016,1.025-.049a10.837,10.837,0,0,0,2.273-.459l.006,0a10.665,10.665,0,0,0,1.365-.541s.006,0,.008,0c.1-.047.2-.1.293-.146l.047-.023c.078-.041.156-.082.234-.125.2-.107.387-.221.576-.342.053-.031.1-.064.156-.1.172-.113.342-.234.506-.357.029-.021.061-.043.09-.066A10.875,10.875,0,0,0,378.508,337.158Zm-4.054,11.766c-.064.051-.131.1-.2.145s-.129.1-.2.139-.113.08-.172.117-.1.064-.146.1q-.243.152-.492.293l-.053.029c-.074.041-.148.08-.223.119-.01.006-.022.01-.031.016l-.012.006c-.094.049-.189.1-.285.141a9.578,9.578,0,0,1-1.138.461c-.051.018-.1.035-.152.051a10.243,10.243,0,0,1-2.152.437c-.32.029-.644.045-.971.045a10.144,10.144,0,0,1-2.654-.348,9.64,9.64,0,0,1-1.3-.441l-.133-.055-.068-.031c-.184-.08-.365-.168-.543-.26l-.086-.045c-.217-.113-.43-.234-.637-.363-.076-.047-.152-.1-.226-.147-.234-.154-.463-.32-.685-.494-.15-.113-.295-.234-.435-.359-.074-.062-.146-.131-.217-.2a9.932,9.932,0,0,1-.785-.812c-.082-.094-.162-.187-.238-.285a.737.737,0,0,1-.049-.061,10.283,10.283,0,1,1,14.279,1.8Z",
    transform: "translate(-344.376 -278.275)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_25",
    "data-name": "Ellipse 25",
    cx: 4.262,
    cy: 4.262,
    r: 4.262,
    transform: "translate(19.657 96.488)",
    fill: "#2f2e41"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    cx: 1.764,
    cy: 1.323,
    rx: 1.764,
    ry: 1.323,
    transform: "translate(17.475 97.829) rotate(-45)",
    fill: "#2f2e41"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_27",
    "data-name": "Ellipse 27",
    cx: 1.323,
    cy: 1.764,
    rx: 1.323,
    ry: 1.764,
    transform: "translate(24.598 96.93) rotate(-66.869)",
    fill: "#2f2e41"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6688",
    "data-name": "Path 6688",
    d: "M409.417,557.17l-.5-.79a1.971,1.971,0,1,0-3.6,1.6l.143.512.163.581a11.127,11.127,0,0,0,1.94-.423l0,0a10.363,10.363,0,0,0,1.366-.542l.007,0c.1-.047.194-.1.293-.145a.421.421,0,0,0,.047-.025c.079-.039.158-.081.234-.123s.155-.086.229-.133Z",
    transform: "translate(-380.399 -448.152)",
    fill: "#cacaca"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 3.617,
    cy: 3.617,
    r: 3.617,
    transform: "translate(20.437 98.15)",
    fill: "#ffb6b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6689",
    "data-name": "Path 6689",
    d: "M392.5,555.42a7.823,7.823,0,0,0-1.47-1.782,2.148,2.148,0,0,0-1.433-.546h-5.1a2.148,2.148,0,0,0-2.144,2.284,2.2,2.2,0,0,0,.089.487,2.3,2.3,0,0,0,.135.335l.251.5.059.025s.007,0,.01,0c.1.042.207.084.313.123a10.182,10.182,0,0,0,1.059.34,10.667,10.667,0,0,0,1.763.318c.347.032.694.049,1.044.049s.687-.017,1.026-.049c.111-.01.222-.022.332-.034a11.128,11.128,0,0,0,1.94-.423l0,0a10.368,10.368,0,0,0,1.366-.542l.007,0c.1-.047.195-.1.293-.145a.416.416,0,0,0,.047-.025c.079-.039.158-.081.234-.123s.155-.086.229-.133.153-.089.229-.135C392.693,555.757,392.6,555.585,392.5,555.42Z",
    transform: "translate(-363.22 -446.557)",
    fill: "#cacaca"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6690",
    "data-name": "Path 6690",
    d: "M383.764,555.2a1.97,1.97,0,0,0-2.614.94l-.453.684-.217.327-.33.5.2.111.091.047c.212.108.426.212.648.308.025.012.052.022.079.034l.059.025s.007,0,.01,0c.1.042.207.084.313.123a10.16,10.16,0,0,0,1.059.34,10.659,10.659,0,0,0,1.762.318l.172-.583.167-.556A1.972,1.972,0,0,0,383.764,555.2Z",
    transform: "translate(-361.56 -448.008)",
    fill: "#cacaca"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6691",
    "data-name": "Path 6691",
    d: "M386.908,518.554a4.919,4.919,0,0,0,2.812.869,3.016,3.016,0,0,1-1.195.492,9.921,9.921,0,0,0,4.052.023,2.623,2.623,0,0,0,.848-.291,1.073,1.073,0,0,0,.524-.7,1.447,1.447,0,0,0-.718-1.28,5.3,5.3,0,0,0-4.451-.89,2.438,2.438,0,0,0-1.318.745,1.2,1.2,0,0,0-.111,1.426Z",
    transform: "translate(-366.654 -419.061)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6692",
    "data-name": "Path 6692",
    d: "M378.511,490.155a10.879,10.879,0,1,0-18.8,10.334c.1.123.2.246.3.364a.2.2,0,0,0,.02.025,10.373,10.373,0,0,0,.812.835c.074.069.15.14.229.207.148.133.3.258.46.379.062.049.123.1.187.145.249.19.51.364.775.534a.019.019,0,0,1,.012,0c.076.047.155.094.234.138s.15.089.224.13l.2.111.091.047c.212.108.426.212.648.308.025.012.052.022.079.034l.059.025s.007,0,.01,0c.1.042.207.084.313.123a10.184,10.184,0,0,0,1.059.34,10.675,10.675,0,0,0,1.762.318c.347.032.694.049,1.044.049s.687-.017,1.026-.049c.111-.01.221-.022.332-.035a11.13,11.13,0,0,0,1.94-.423l0,0a10.385,10.385,0,0,0,1.366-.542l.007,0c.1-.047.194-.1.293-.145a.429.429,0,0,0,.047-.025c.079-.039.158-.081.234-.123s.155-.086.229-.133.153-.089.229-.135l.118-.074c.054-.032.1-.064.158-.1.074-.047.148-.1.219-.15.1-.066.192-.135.286-.207a1.061,1.061,0,0,0,.091-.066A10.886,10.886,0,0,0,378.511,490.155Zm-4.054,11.764c-.064.052-.131.1-.2.145s-.131.1-.2.14-.113.079-.172.116l-.017.012c-.042.03-.086.057-.128.084l-.089.054c-.086.054-.172.106-.261.155-.047.03-.1.057-.143.084l-.052.03c-.076.042-.15.079-.224.118-.01.007-.022.01-.029.017a.019.019,0,0,0-.012,0c-.094.049-.19.1-.285.14a9.514,9.514,0,0,1-1.14.46c-.049.017-.1.037-.15.052a10.3,10.3,0,0,1-1.928.414c-.074.01-.15.017-.226.025-.32.03-.642.044-.97.044-.291,0-.583-.012-.871-.037a10.154,10.154,0,0,1-1.782-.31,9.434,9.434,0,0,1-1.3-.443l-.066-.027-.066-.027c-.025-.01-.044-.02-.069-.032-.16-.069-.32-.145-.475-.224l-.066-.034-.086-.044-.153-.081c-.165-.089-.327-.185-.485-.283-.059-.037-.123-.076-.182-.116l-.044-.03c-.138-.094-.276-.187-.411-.288-.091-.069-.185-.135-.273-.207-.15-.113-.3-.234-.436-.359-.074-.062-.148-.131-.217-.194a9.769,9.769,0,0,1-.785-.812c-.081-.094-.163-.187-.239-.286-.017-.02-.032-.039-.049-.062a10.284,10.284,0,1,1,14.28,1.8Z",
    transform: "translate(-344.378 -393.608)",
    fill: "#3f3d56"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6693",
    "data-name": "Path 6693",
    d: "M346.7,278.15a25.568,25.568,0,1,0,1.45,37.759l31.362,26.463a2.356,2.356,0,1,0,3.042-3.6l0,0-31.362-26.463A25.569,25.569,0,0,0,346.7,278.15Zm-2.022,31.61a19.155,19.155,0,1,1-2.287-26.993h0A19.155,19.155,0,0,1,344.674,309.76Z",
    transform: "translate(-304.638 -234.754)",
    fill: "#3f3d56"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_6694",
    "data-name": "Path 6694",
    d: "M330.582,355.448a19.156,19.156,0,0,1-3.25-25.751q-.549.553-1.062,1.159a19.155,19.155,0,1,0,29.28,24.706q.512-.606.964-1.242A19.156,19.156,0,0,1,330.582,355.448Z",
    transform: "translate(-317.539 -278.155)",
    opacity: 0.3,
    style: {
      isolation: "isolate"
    }
  }), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6695",
    "data-name": "Path 6695",
    d: "M699.734,477.664a2.645,2.645,0,0,0-.755-3.984l-5.716-23.4-4.17,1.331,6.173,23.238a2.659,2.659,0,0,0,4.469,2.813Z",
    transform: "translate(-594.45 -369.056)",
    fill: "#ffb6b6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6696",
    "data-name": "Path 6696",
    d: "M386.448,341.653l-3.048,2.629-4.264,3.676-1.883-9.635-.2-1-.155-.8,4.32-7.525,3.6.207.246.015,0,.054.057.5.738,6.641.017.16Z",
    transform: "translate(-284.12 -248.011)",
    fill: "#3f3d56"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6697",
    "data-name": "Path 6697",
    d: "M321.125,610.426h-3.018l-1.436-11.641h4.454Z",
    transform: "translate(-238.716 -451.384)",
    fill: "#ffb6b6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6698",
    "data-name": "Path 6698",
    d: "M612.728,766.3H603v-.123a3.788,3.788,0,0,1,3.787-3.788h5.944Z",
    transform: "translate(-529.55 -604.333)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6699",
    "data-name": "Path 6699",
    d: "M449.125,611.426h-3.018l-1.436-11.641h4.454Z",
    transform: "translate(-335.206 -452.138)",
    fill: "#ffb6b6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6700",
    "data-name": "Path 6700",
    d: "M740.728,767.3H731v-.123a3.788,3.788,0,0,1,3.787-3.788h5.944Z",
    transform: "translate(-626.04 -605.087)",
    fill: "#2f2e41"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6701",
    "data-name": "Path 6701",
    d: "M649.8,520.534l-8.124,1.231-11.818-40-12.552,40.243L608.2,520.78l11.816-46.772v-3.693l1.6-5.539-.167-1.5-1.164-10.484-.5-4.547-.033-.294a1,1,0,0,1,.786-1.087h0l3.791-.8h6.2l3.656,1.007.251.069.113.032-.057.473-.857,7.183-.047.394-.827,6.925-.182,1.519c7.139,5.169,7.385,10.339,7.385,10.339Z",
    transform: "translate(-533.472 -365.88)",
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_29",
    "data-name": "Ellipse 29",
    cx: 6.046,
    cy: 6.046,
    r: 6.046,
    transform: "translate(87.155 64.982)",
    fill: "#ffb6b6"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3528",
    "data-name": "Rectangle 3528",
    width: 12.062,
    height: 1.723,
    transform: "translate(87.591 97.964) rotate(-7.451)",
    fill: "#3f3d56"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6702",
    "data-name": "Path 6702",
    d: "M583.115,503.156a2.585,2.585,0,0,1,.324.248l11.83-3.016.807-2.854,4.466.655-.938,5.191a1.969,1.969,0,0,1-1.732,1.608l-13.813,1.455a2.584,2.584,0,1,1-.945-3.288Z",
    transform: "translate(-511.567 -404.676)",
    fill: "#ffb6b6"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6703",
    "data-name": "Path 6703",
    d: "M649.223,450.534l-2.092-1.6c-.566-.215-1.341.4-1.477.985L642.7,461.981l6.154,4.431.862-1.354Z",
    transform: "translate(-559.479 -368.007)",
    fill: "#3f3d56"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3350",
    "data-name": "Group 3350",
    transform: "translate(88.243 80.189)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6704",
    "data-name": "Path 6704",
    d: "M676.609,454.29a16.655,16.655,0,0,1-1.6.542c-.172.052-.35.1-.524.148a16.254,16.254,0,0,1-3.53.571,11.116,11.116,0,0,1-1.541-.042,8.674,8.674,0,0,1-1.622-.32l-.054-.015A7.116,7.116,0,0,1,664.8,453.5a5.8,5.8,0,0,1-.519-.578,5.228,5.228,0,0,1-1.123-4.069,3.482,3.482,0,0,1,.084-.387,6.178,6.178,0,0,1,.367-1.009c.066-.153.14-.3.219-.45l2.782-.94h5.3l3.656,1.007.246.015,0,.054.113.032-.057.473Z",
    transform: "translate(-663.103 -446.068)"
  }))), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6705",
    "data-name": "Path 6705",
    d: "M651.922,379.437a4.289,4.289,0,0,0-3.253.681,2.092,2.092,0,0,0-.331,3c.739.687,1.894.525,2.883.72a3.9,3.9,0,0,1,3.048,3.731c-.015,2.5-2.418,4.4-2.85,6.868a5.357,5.357,0,0,0,1.643,4.645,7.751,7.751,0,0,0,4.616,2.006,14.266,14.266,0,0,0,5.072-.529,14.107,14.107,0,0,0,4.686-2.065,7.614,7.614,0,0,0,2.981-4.076,5.251,5.251,0,0,0-1.026-4.83c-1.319-1.457-3.514-1.958-4.655-3.559-1.279-1.794-.806-4.349-1.841-6.294a5.883,5.883,0,0,0-3.4-2.651,15.144,15.144,0,0,0-4.355-.6,5.771,5.771,0,0,0-2.289.25,2.068,2.068,0,0,0-1.39,1.7A1.01,1.01,0,0,0,651.922,379.437Z",
    transform: "translate(-563.353 -313.414)",
    fill: "#2f2e41"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_6706",
    "data-name": "Path 6706",
    d: "M606.4,778.173H512.608a.246.246,0,0,1,0-.492H606.4a.246.246,0,1,1,0,.492Z",
    transform: "translate(-461.226 -615.86)",
    fill: "#cacaca"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextSteps);
export default __webpack_public_path__ + "static/media/next-steps.3fae0538.svg";
export { ForwardRef as ReactComponent };